import React from 'react';
import { render } from '@testing-library/react';
import { TestComponent } from '@components';

interface TestHelperHookTestInput<T> {
	hookFn: () => T;
	state?: Record<string, any>;
}

interface TestHelperServiceHookTestInput<T> {
	hookFn: () => T;
	apiMethodName: string;
	successResponse?: any;
	state?: Record<string, any>;
}

export class TestHelper {
	static hookTest = <T,>(input: TestHelperHookTestInput<T>): T => {
		const { hookFn, state } = input;
		const returnVal = {};

		const TestComp: React.FC = () => {
			Object.assign(returnVal, hookFn());
			return null;
		};

		render(
			<TestComponent state={state}>
				<TestComp />
			</TestComponent>
		);

		return returnVal as any;
	};

	static serviceHookTest = async <T,>(input: TestHelperServiceHookTestInput<T>): Promise<T> => {
		const { hookFn, apiMethodName, successResponse, state } = input;
		const returnVal: any = {};

		const TestComp: React.FC = () => {
			Object.assign(returnVal, hookFn());
			return null;
		};

		render(
			<TestComponent state={state}>
				<TestComp />
			</TestComponent>
		);

		return returnVal.fetch();
	};
}
